/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Radio } from 'antd'

const RadioButtonF = (props) => {
  const {
    options, modalProps, onChange, value, id
  } = props

  const onChangeRadio = (value) => {
    onChange(value)
  }
  return (
    <Radio.Group
      id={id}
      buttonStyle="solid"
      {...modalProps}
      onChange={onChangeRadio}
      value={value}>
      {options.map(item => {
        return (
          <Radio.Button key={item.id} value={item.id}>{item.value}</Radio.Button>
        )
      })}
    </Radio.Group>
  )
}
export default RadioButtonF

RadioButtonF.defaultProps = {
  modalProps: {},
  options: []
}
